module.exports = __webpack_public_path__ + "img/liverpool-toluca.cb384618.jpg";